import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationLeadAvancementApiService } from './organization-lead-avancement-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationLeadAvancementApiService extends GeneratedOrganizationLeadAvancementApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
